import { render, staticRenderFns } from "./ClientSelection.vue?vue&type=template&id=ad2b9f12&scoped=true&"
import script from "./ClientSelection.vue?vue&type=script&lang=js&"
export * from "./ClientSelection.vue?vue&type=script&lang=js&"
import style0 from "./ClientSelection.vue?vue&type=style&index=0&id=ad2b9f12&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad2b9f12",
  null
  
)

export default component.exports